import { render, staticRenderFns } from "./DialogIntegracaoGrupos.vue?vue&type=template&id=5bb86464&scoped=true&"
import script from "./DialogIntegracaoGrupos.vue?vue&type=script&lang=js&"
export * from "./DialogIntegracaoGrupos.vue?vue&type=script&lang=js&"
import style0 from "./DialogIntegracaoGrupos.vue?vue&type=style&index=0&id=5bb86464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb86464",
  null
  
)

export default component.exports